import { EmployeePermissions } from '../company/employeeRole.data';

/**
 * Checks for an explicitly granted permission outside the Offers module.
 * @param {EmployeePermissions | null | undefined} permissions
 * @return {boolean}
 */
export function hasNonOfferPermissions(permissions: EmployeePermissions | null | undefined): boolean {
  return Object.entries(permissions ?? {}).some(
    ([module, grants]) => module !== 'offers' && Object.values(grants ?? {}).some((granted) => granted === true)
  );
}

/**
 * Keeps explicitly granted permissions and omits empty modules before saving them.
 * @param {EmployeePermissions | null | undefined} permissions
 * @return {EmployeePermissions}
 */
export function getGrantedEmployeePermissions(permissions: EmployeePermissions | null | undefined): EmployeePermissions {
  const result: Record<string, Record<string, true>> = {};
  for (const [module, grants] of Object.entries(permissions ?? {})) {
    if (grants == null || typeof grants !== 'object') continue;
    const enabled: Record<string, true> = {};
    for (const [permission, granted] of Object.entries(grants)) {
      if (granted === true) enabled[permission] = true;
    }
    if (Object.keys(enabled).length > 0) result[module] = enabled;
  }
  return result;
}
